import { styled } from 'styled-components';
import { StoredTheme } from '~/gql/theme/theme';
import { renderFullPath } from '~/utils/common/utils';
//import { classic } from '~/themes/classic';
import iconMedal from '@assets/images/icon/icon-medal.png';
import { SSpanTitle, SSpanTitleSmall } from '~/components/styles/styles';
import { classic } from '~/themes';
import { useLingui } from '@lingui/react';
import Button from '~/components/ui/button';

type IProps = {
  theme: StoredTheme;
  onClick?: () => void;
  modeName: string;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function ThemePresentation({ theme, modeName, onClick }: TProps) {
  const { i18n } = useLingui();
  //   {theme.name}
  return (
    <Container onClick={onClick}>
      <SDivMedal>
        <SDivMedalContent>
          <SImgMedal src={iconMedal} alt="" />
          <SDivContent>
            <SSpanTitleSmall $color={classic.token?.colorWhite}>
              {modeName}
            </SSpanTitleSmall>
            <SSpanTitle $align="center" $color={classic.token?.colorWhite}>
              {theme.name}
            </SSpanTitle>
            <Button
              color="primary"
              type="submit"
              width="auto"
              minWidth="100px"
              onClick={onClick}
            >
              {i18n._('common.play')}
            </Button>
          </SDivContent>
          <SThemeImg src={renderFullPath(theme.fileName)} alt="" />
        </SDivMedalContent>
      </SDivMedal>
    </Container>
  );
}

const SDivMedalContent = styled.div`
  height: 100%;
  width: auto;
  position: relative;

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;

const SImgMedal = styled.img`
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px;
  height: 100%;
  width: 100%;
  @media screen and (max-width: 450px) {
    padding: 0;
  }
`;

const SDivContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: absolute;
  top: 20%;
  height: 37%;
  width: 37%;
  transform: translate(-50%);
  left: 50%;
`;

const SDivMedal = styled.div<{ $background?: string }>`
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;
`;

const SThemeImg = styled.img`
  position: absolute;
  top: -5%;
  left: 50%;
  transform: translateX(-50%);
  width: 28%;
`;
